import React, { useState, useEffect } from 'react';
import { useMicVAD, utils } from "@ricky0123/vad-react";
import encodeWav from 'audiobuffer-to-wav';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import HamsterAnimation from '../../animation/loader';
import HamsterAnimationstill from '../../animation/stillloader';

const MyComponent = ({ userid, socketRef }) => {
  const [audioList, setAudioList] = useState([]);
  const [autoken, setAutoken] = useState(null); // State to hold the token
  const { getAccessTokenSilently } = useAuth0();
  

  useEffect(() => {
    let ignore = false;

    // Function to get the access token
    const getToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        if (!ignore) setAutoken(token);
      } catch (error) {
        if (!ignore) console.error("Error fetching access token:", error);
      }
    };

    // Get the token immediately and every 3 minutes thereafter
    getToken(); // Get the token on initial render
    const tokenInterval = setInterval(getToken, 180000); // Refresh token every 3 minutes

    // Clear interval on unmount
    return () => { 
      ignore = true; 
      clearInterval(tokenInterval); 
    };
  }, [getAccessTokenSilently]);

  /*const sendAudio = async (audioFloat32Array) => {
    const wavBuffer = utils.encodeWAV(audioFloat32Array);
    const blob = new Blob([wavBuffer], { type: 'audio/wav' });
    const formData = new FormData();
    formData.append('file', blob);
    formData.append('user_id', userid);
  
    try {
      const headers = {Authorization: `Bearer ${autoken}`,};
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/audio`, formData, { headers }).then((response) => {
        console.log("User id in transcription:", response);
    })
      const base64 = utils.arrayBufferToBase64(wavBuffer);
      const url = `data:audio/wav;base64,${base64}`;
      setAudioList((old) => [url, ...old]);
    } catch (error) {
      console.error('Error sending audio data:', error);
    }
  };*/
  const sendAudio = async (audioFloat32Array) => {
    const wavBuffer = utils.encodeWAV(audioFloat32Array);
    const blob = new Blob([wavBuffer], { type: 'audio/wav' });
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
        socketRef.current.send(blob);
    }
    const base64 = utils.arrayBufferToBase64(wavBuffer);
    const url = `data:audio/wav;base64,${base64}`;
    setAudioList((old) => [url, ...old]);
};
  

  const vad = useMicVAD({
    startOnLoad: false,
    additionalAudioConstraints: {
      echoCancellation: true,
      noiseSuppression: true,
      autoGainControl: true,
      sampleSize: 24,
    },
    onSpeechEnd: sendAudio,
  });
  

  const activateVAD = () => {
    console.log('vad toggled');
    console.log(vad);
    vad.toggle();
  };

  

/*list of audio devices*/




  return (
    <div className='content-wrapper-header2'>
      {userid=== null && <div><span style={{color: 'red'}}>not ready yet</span></div>}
      <div>{vad.userSpeaking ? <HamsterAnimation/> : <HamsterAnimationstill/>}</div>
      <button className={`content-button status-button ${vad.listening ? 'listening' : 'not-listening'} open`} onClick={activateVAD}>
        {vad.listening ? <span style={{color: 'red'}}>stop</span> : <span style={{color: 'rgba(0, 255, 0)'}}>start</span>}
      </button>
      <h3>{vad.listening ? <span style={{color: 'rgba(0, 255, 0)'}}>detectando voz</span>: "detección de voz detenida"}</h3>

    </div>
  );
};

export default MyComponent;
